import { DetailedDish, BriefDish, Gin, Tonic } from "./../../types/menuTypes"
import { ContextStatus, initialContextStatus } from "../../types/statusTypes"
import { Promo } from "../../types/promoType"

export interface State {
  status: ContextStatus
  entrees: DetailedDish[]
  plats: DetailedDish[]
  desserts: BriefDish[]
  futs: BriefDish[]
  bouteilles: BriefDish[]
  vinsRouges: BriefDish[]
  vinsBlancs: BriefDish[]
  cocktails: DetailedDish[]
  gins: Gin[]
  tonics: Tonic[]
  menuCollections: string[]
  promotions: Promo[]
  activePromotions: Promo[]
}

export enum Actions {
  setPromotions = "SET_PROMOTIONS",
  setActivePromotions = "SET_ACTIVE_PROMOTIONS",
  setMenu = "SET_MENU",
  setMenuCollections = "SET_MENU_COLLECTIONS",
  setStatus = "SET_STATUS",
}

interface Action {
  type: Actions
  payload: Partial<State>
}

export const initialState: State = {
  status: initialContextStatus,
  entrees: [],
  plats: [],
  desserts: [],
  futs: [],
  bouteilles: [],
  vinsRouges: [],
  vinsBlancs: [],
  cocktails: [],
  gins: [],
  tonics: [],
  menuCollections: [],
  promotions: [],
  activePromotions: [],
}

const firestoreReducer = (state: State, action: Action): State => {
  const { type, payload } = action
  switch (type) {
    case Actions.setPromotions:
      // console.log("SET_PROMOTIONS", payload)

      return {
        ...state,
        promotions: payload.promotions ?? [],
      }

    case Actions.setActivePromotions:
      // console.log("SET_ACTIVE_PROMOTIONS", payload)

      return {
        ...state,
        activePromotions: payload.activePromotions ?? [],
      }

    case Actions.setMenu:
      // console.log("SET_MENU", payload)

      return {
        ...state,
        entrees: payload.entrees ?? [],
        plats: payload.plats ?? [],
        desserts: payload.desserts ?? [],
        futs: payload.futs ?? [],
        bouteilles: payload.bouteilles ?? [],
        vinsRouges: payload.vinsRouges ?? [],
        vinsBlancs: payload.vinsBlancs ?? [],
        cocktails: payload.cocktails ?? [],
        gins: payload.gins ?? [],
        tonics: payload.tonics ?? [],
      }

    case Actions.setMenuCollections:
      // console.log("SET_MENU_COLLECTIONS", payload)

      return {
        ...state,
        menuCollections: payload.menuCollections ?? [],
      }
    case Actions.setStatus:
      // console.log("SET_STATUS", payload)
      return {
        ...state,
        status: payload.status!,
      }

    default:
      throw new Error(`No case for type ${type} found in authReducer.`)
  }
}

export default firestoreReducer
